module.exports = __webpack_public_path__ + "img/s-for-sparkle_banner.6ca6a805.jpg";